import Vue from "vue";
import defaultLogo from "@/assets/GLHF_450.png";

// Site-wide brand (Dashboard -> Settings -> Customization -> Branding), read from the
// Dashboard's public /brand.json. Remembered in localStorage so a reload paints the last
// known name/logo instead of flashing "GLHF Party" while the fetch is in flight. If the
// Dashboard can't be reached the bundled GLHF defaults stay.
const STORAGE_KEY = "glhf-brand";
const HEX_COLOR = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const DEFAULT = {
  name: "GLHF Party",
  words: [
    { text: "GLHF", color: "" },
    { text: "Party", color: "" }
  ],
  logoUrl: defaultLogo,
  faviconUrl: null
};

function remembered() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const value = raw ? JSON.parse(raw) : null;
    return value && Array.isArray(value.words) && value.words.length
      ? value
      : null;
  } catch (e) {
    return null;
  }
}

const brand = Vue.observable({
  ...DEFAULT,
  ...(remembered() || {}),
  defaultLogo
});

function applyFavicon(url) {
  if (!url) return;
  document
    .querySelectorAll(
      "link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']"
    )
    .forEach(link => {
      link.href = url;
      link.removeAttribute("sizes");
      link.type = "image/png";
    });
}

export function loadBrand(dashboardUrl) {
  applyFavicon(brand.faviconUrl);
  const base = String(dashboardUrl || "https://dashboard.glhfparty.dk").replace(
    /\/+$/,
    ""
  );
  return fetch(`${base}/brand.json`)
    .then(res => (res.ok ? res.json() : null))
    .then(data => {
      if (!data || !Array.isArray(data.words) || !data.words.length) return;
      const next = {
        name: String(data.name || DEFAULT.name),
        words: data.words.map(word => ({
          text: String(word.text || ""),
          color: HEX_COLOR.test(word.color || "") ? word.color : ""
        })),
        logoUrl: `${base}${data.logoUrl}`,
        faviconUrl: `${base}${data.faviconUrl}`
      };
      Object.assign(brand, next);
      applyFavicon(next.faviconUrl);
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (e) {
        // storage blocked (private mode) - this page view still has the brand
      }
    })
    .catch(() => {});
}

export default brand;
